
export class TodoFakeDb {
    public static todos = [
        {
            'id': '561551bd7fe2ff461101c192',
            'title': 'Calendar new functionality to implement',
            'notes': 'New Calendar Menu should be added in the existing list. This calendar will have two more sub menus i) Leave ii) Clients',
            'startDate': 'Wednesday, January 29, 2017 3:17 PM',
            'dueDate': null,
            'completed': false,
            'starred': false,
            'important': false,
            // 'deleted': false,
            'tags': [1]
        },
        {
            'id': '561551bd4ac1e7eb77a3a750',
            'title': 'Employee ERP > Profile Image ',
            'notes': 'The added profile image has not been showing if user logout and login into the application',
            'startDate': 'Sunday, February 1, 2018 1:30 PM',
            'dueDate': 'Friday, December 30, 2019 10:07 AM',
            'completed': false,
            'starred': false,
            'important': true,
            // 'deleted': false,
            'tags': [1, 4]
        },
        {
            'id': '561551bd917bfec2ddef2d49',
            'title': 'Attendance page > Issue in filter and pagination',
            'notes': 'If admin, choose the in-time filter and goes to the last page, now if the admin changes the filter option from in-time to absentees, it was not populating result this is due to the last page the admin currently views.',
            'startDate': 'Friday, April 11, 2017 3:43 AM',
            'dueDate': 'Wednesday, July 26, 2017 11:14 AM',
            'completed': false,
            'starred': true,
            'important': true,
            // 'deleted': false,
            'tags': [4, 2]
        },
        {
            'id': '561551bdeeb2fd6877e18c29',
            'title': 'Admin ERP > General suggestion',
            'notes': 'Need option to create and edit the Roles, designation, department, location and Reporting To values.',
            'startDate': 'Wednesday, May 7, 2017 4:14 AM',
            'dueDate': 'Friday, December 15, 2017 4:01 AM',
            'completed': false,
            'starred': true,
            'important': true,
            // 'deleted': false,
            'tags': [2]
        },
        {
            'id': '561551bd7fe2ff461101c192',
            'title': 'Calendar new functionality to implement',
            'notes': 'New Calendar Menu should be added in the existing list. This calendar will have two more sub menus i) Leave ii) Clients',
            'startDate': 'Wednesday, January 29, 2017 3:17 PM',
            'dueDate': null,
            'completed': false,
            'starred': false,
            'important': false,
            // 'deleted': false,
            'tags': [1]
        },
        {
            'id': '561551bd4ac1e7eb77a3a750',
            'title': 'Employee ERP > Profile Image ',
            'notes': 'The added profile image has not been showing if user logout and login into the application',
            'startDate': 'Sunday, February 1, 2018 1:30 PM',
            'dueDate': 'Friday, December 30, 2019 10:07 AM',
            'completed': false,
            'starred': false,
            'important': true,
            // 'deleted': false,
            'tags': [1, 2]
        },
        {
            'id': '561551bd917bfec2ddef2d49',
            'title': 'Employee ERP > Forgot Password',
            'notes': 'Need forgot password option in login page.',
            'startDate': 'Friday, April 11, 2017 3:43 AM',
            'dueDate': 'Wednesday, July 26, 2017 11:14 AM',
            'completed': false,
            'starred': true,
            'important': true,
            // 'deleted': false,
            'tags': [1, 2]
        },
        {
            'id': '561551bdeeb2fd6877e18c29',
            'title': 'Admin ERP > General suggestion',
            'notes': 'Need option to create and edit the Roles, designation, department, location and Reporting To values.',
            'startDate': 'Wednesday, May 7, 2017 4:14 AM',
            'dueDate': 'Friday, December 15, 2017 4:01 AM',
            'completed': true,
            'starred': true,
            'important': false,
            // 'deleted': false,
            'tags': [2]
        }
    ];

    public static filters = [
        {
            'id': 0,
            'handle': 'starred',
            'title': 'Starred',
            'icon': 'star'
        },
        {
            'id': 1,
            'handle': 'important',
            'title': 'Priority',
            'icon': 'error'
        },
        {
            'id': 2,
            'handle': 'assigned',
            'title': 'Assigned Task',
            'icon': 'schedule'
        },
        {
            'id': 3,
            'handle': 'created task',
            'title': 'Created Task',
            'icon': 'today'
        },
        {
            'id': 4,
            'handle': 'completed',
            'title': 'Done',
            'icon': 'check'
        },
        // {
        // 'id': 4,
        // 'handle': 'deleted',
        // 'title': 'Deleted',
        // 'icon': 'delete'
        // }
    ];

    public static tags = [
        {
            'id': 1,
            'handle': 'proposal',
            'title': 'Proposal',
            'color': '#388E3C'
        },
        {
            'id': 2,
            'handle': 'sales',
            'title': 'Sales',
            'color': '#F44336'
        },
        {
            'id': 3,
            'handle': 'documentation',
            'title': 'Documentation',
            'color': '#FF9800'
        },
        {
            'id': 4,
            'handle': 'hiring',
            'title': 'Hiring',
            'color': '#0091EA'
        },
        {
            'id': 5,
            'handle': 'project management',
            'title': 'Project Management',
            'color': 'pink'
        },
        // {
        //     'id': 6,
        //     'handle': 'documentation',
        //     'title': 'Documentation',
        //     'color': 'grey'
        // },
        // {
        //     'id': 7,
        //     'handle': 'git process',
        //     'title': 'Git Process',
        //     'color': 'orange'
        // }
    ];
}